import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Autocomplete } from '@totalsoft/rocket-ui';
import { useClientQuery } from 'hooks/apollo';
import { PARTNER_LIST_QUERY } from '../io';

const PartnerAutocomplete = ({ label, disabled, helperText, error, value, onChange }) => {
  const clientQuery = useClientQuery();

  const filterOptions = useCallback(
    async value => {
      const inputText = value?.toString() || '';
      if (!inputText) return [];

      const { data } = await clientQuery(PARTNER_LIST_QUERY, {
        variables: { search: inputText }
      });
      if (!data) return [];
      const opts = data.partnerList;
      return opts;
    },
    [clientQuery]
  );

  return (
    <Autocomplete
      id='partner-selection-autocomplete'
      required
      label={label}
      value={value}
      onChange={onChange}
      loadOptions={filterOptions}
      error={error}
      helperText={helperText}
      disabled={disabled}
      noOptionsText='Start typing to search for a partner'
    />
  );
};

PartnerAutocomplete.propTypes = {
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  helperText: PropTypes.string,
  error: PropTypes.bool,
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired
};

export default PartnerAutocomplete;
